import { memo, useState } from 'react';
import services from 'services';
import { saveAs } from 'file-saver';

import { EventDocumentView } from 'components';

interface Props {
  link: string;
  name: string;
  withIcon?: boolean;
}

const EventDocument: React.FC<Props> = ({ link, name, withIcon }) => {
  const [loading, setLoading] = useState(false);

  const download = async () => {
    try {
      setLoading(true);

      const { data } = await services.get(link, {
        responseType: 'blob',
        headers: {
          Accept: '*/*',
        },
      });

      saveAs(data, name);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <EventDocumentView
      download={download}
      loading={loading}
      name={name}
      withIcon={withIcon}
    />
  );
};

export default memo(EventDocument);
